import Top8Standings from '../components/common/Top8Standings';
import './Top8StandingsPage.css';

export default function Top8StandingsPage() {
  return (
    <div className="top8-standings-page">
      <Top8Standings />
    </div>
  );
}
